import React from "react";
import FormContext from "src/context/FormContext";
import { NewPremiseProps } from "../types";

export const useNewPremiseEffect = (props: NewPremiseProps) => {
  const [submitClicked, setSubmitClicked] = React.useState(false);
  const { setDisplayingSnackbar, setFormState } = React.useContext(FormContext);
  const premiseBlockRef = React.useRef(null);
  const accountBlockRef = React.useRef(null);
  const electricityBlockRef = React.useRef(null);
  const gasLineBlockRef = React.useRef(null);
  const gasBothBlockRef = React.useRef(null);
  const gasMeterBlockRef = React.useRef(null);
  const internetBlockRef = React.useRef(null);
  const closeTransferBlockRef = React.useRef(null);
  const { addressString, computedAddressState } = props;
  React.useEffect(() => {
    if (addressString) {
      setFormState((prevState) => ({
        ...prevState,
        address: addressString,
      }));
    }
    if (computedAddressState) {
      setFormState((prevState) => ({
        ...prevState,
        state: computedAddressState,
      }));
    }
  }, []);

  return {
    setDisplayingSnackbar,
    premiseBlockRef,
    accountBlockRef,
    electricityBlockRef,
    gasLineBlockRef,
    gasBothBlockRef,
    gasMeterBlockRef,
    internetBlockRef,
    closeTransferBlockRef,
    submitClicked,
    setSubmitClicked,
  };
};
